import { Link } from "react-router-dom";
import { Bunting, LogoMark, Sparkle } from "@/components/art/Poster";
import { useCourtyard } from "@/context/CourtyardContext";

export default function Footer({ onReplay }) {
  const { event: ev } = useCourtyard();
  return (
    <footer className="bg-navy-print on-dark relative overflow-hidden pb-28 text-[var(--cream)] md:pb-10" data-testid="site-footer">
      <Bunting className="h-[48px] w-full md:h-[64px]" width={1440} flags={26} />
      <div className="relative mx-auto max-w-7xl px-5 pt-10 sm:px-8 lg:px-12">
        <Sparkle className="absolute right-8 top-8 w-8" />
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <LogoMark className="h-14 w-14" />
            <div>
              <p className="font-poster text-2xl">{ev.title}</p>
              <p className="text-sm text-[#E5DFD2]" data-testid="footer-opening-line">{ev.opening_line}</p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm" aria-label="Footer">
            <button type="button" onClick={onReplay} className="min-h-[44px] font-bold underline decoration-[var(--yellow)] decoration-2 underline-offset-4" data-testid="replay-intro-button">
              Light the diya again
            </button>
            <Link to="/host" className="inline-flex min-h-[44px] items-center text-[#D9D4C8] hover:text-white" data-testid="host-dashboard-link">
              Host login
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
